import { graphql } from 'react-relay';

export const ChargeCustomerRegister = graphql`
  mutation ChargeCustomerRegisterMutation(
    $input: ChargeCustomerRegisterInput!
  ) {
    ChargeCustomerRegister(input: $input) {
      error
      charge {
        ...Payment_charge
      }
    }
  }
`;
